// extracted by mini-css-extract-plugin
export default {"tabs":"tabbed-content_tabs__enRqe","tab":"tabbed-content_tab__MP6RX","selected":"tabbed-content_selected__RcQKh"};